module.exports = __webpack_public_path__ + "images/mobile/stars/document-b5a2dec402b633f649d909770cebdcf3.png";